import React from "react";

export const FORM_LANGS = [
  { code: "en", label: "EN" },
  { code: "mk", label: "MK" },
  { code: "sq", label: "SQ" },
] as const;

export type FormLang = (typeof FORM_LANGS)[number]["code"];

interface LanguageTabsProps {
  active: string;
  onChange: (lang: FormLang) => void;
}

// Reusable language switcher for multilingual admin modals.
// Shows EN / MK / SQ tabs; the parent renders the fields for the active tab.
const LanguageTabs: React.FC<LanguageTabsProps> = ({ active, onChange }) => (
  <div className="flex gap-1 border-b border-gray-200 mb-6">
    {FORM_LANGS.map((l) => (
      <button
        key={l.code}
        type="button"
        onClick={() => onChange(l.code)}
        className={`px-5 py-2 text-sm font-semibold rounded-t-lg transition-colors -mb-px border-b-2 ${
          active === l.code
            ? "border-brand-500 text-brand-700 bg-brand-50"
            : "border-transparent text-gray-500 hover:text-brand-600 hover:bg-brand-50"
        }`}
      >
        {l.label}
      </button>
    ))}
  </div>
);

export default LanguageTabs;
